export class ExternalBranchesEntity {
  id?: number
  branch?: {
    id?: number
    name?: string | null
  }
  url?: string | null
  createdAt?: string
}
